import { Typography, Container, Grid } from '@mui/material';
import { Topbar, Page } from 'components';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthStore, RoutingStore } from '../stores';
import { MainSidebar, StatisticsCharts, StatisticsTreeView } from '../views';
import { QuestionButton } from 'views/statistics/questionButton';
import { WalkthroughModal} from 'views/statistics/walkthroughModal';

export interface IStatisticsProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

/**
 * Analytics section for admins and managers
 *
 * @type Analys, Manager
 */
export const Statistics = inject('authStore', 'routingStore')(observer((props: IStatisticsProps) => {
    const { authStore, routingStore } = props;
    const [openModal,    setOpenModal]    = React.useState<boolean>(false);
    const { t } = useTranslation();

    return (
      <Page sidebar={<MainSidebar />} topbar={<Topbar />}>
        <Container sx={{padding:{xs: 4}, maxWidth:{lg: 'lg'}}}>
          <Grid pt={3} container>
            <Grid
              item
              xs             = {12}
              mb             = {3}
              display        = 'flex'
              justifyContent = 'space-between'
            >
              <Typography variant='h2'>{t('statistics')}</Typography>
              <QuestionButton visible={true} onClick={() => setOpenModal(true)}/>
              <WalkthroughModal open={openModal} onClose={() => setOpenModal(false)}/>
            </Grid>
            <Grid xs={12} mb={3} item>
              <Typography variant='body1'>
                {t('statistics_view_desc')}
              </Typography>
            </Grid>
            <StatisticsCharts />
            <StatisticsTreeView />
          </Grid>
      </Container>
    </Page>
  );
}));
